import React, { useState , useEffect}  from 'react';
import { MdOutlineCancel } from 'react-icons/md';
import { useStateContext } from '../../contexts/ContextProvider';
import { useDropMutations } from '../../hooks'
import { ButtonSubmit, FooterPages } from '..';
import Select from 'react-select';
import {getComunas} from "../../services/Comunas";

import { Toaster,toast } from 'react-hot-toast';

const initialState = {
  empresa:'',
  codigo: '',
  nombrePunto: '',
  direccion: '',
  telefono: '',
  email: '',
  descripcion: '',
  idComuna: '',
  nombreCiudad: '',
  contacto: '',
  estado: 'Activo',
};

const NewDrop = ({vecinoData, onChangeVecino}) => {
  const { currentColor, isClicked, setIsClicked } = useStateContext();
  const [formData, setFormData] = useState(initialState);
  const [comunaData, setComunaData] = useState([]);
  const { addDrop, updateDropD } = useDropMutations();
  const inputClass = "text-[11px] border border-gray-300 p-1.5 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-400";

  useEffect(() => {
    if(vecinoData) {
      setFormData(vecinoData);
    }
  }, [vecinoData]);

 useEffect(()=>{
    const fetchData = async () => {
      const misComunas = await getComunas();
      setComunaData(misComunas);
    };
    fetchData();
  },[]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const comunaOptions = comunaData.map((item) => ({
    value: item._id,
    label: `${item.codigoComuna} - ${item.nombreComuna}`,
  }));

  const handleSubmit = async (e) =>{
    e.preventDefault();

    // Validaciones
    if( formData.codigo === '' || formData.codigo === null || formData.codigo === undefined )
      {
        toast.error('Debe ingresar un código!');
        return;
      }
    if( formData.nombrePunto === '' || formData.nombrePunto === null || formData.nombrePunto === undefined )
      {
        toast.error('Debe ingresar un nombre para el Punto de Drop Off!');
        return;
      }
    if( formData.direccion === '' || formData.direccion === null || formData.direccion === undefined )
      {
        toast.error('Debe ingresar una dirección!');
        return;
      }
    if( formData.telefono === '' || formData.telefono === null || formData.telefono === undefined )
      {
        toast.error('Debe ingresar un teléfono!');
        return;
      }
      if( formData.idComuna === '' || formData.idComuna === null || formData.idComuna === undefined )
      {
        toast.error('Debe seleccionar una Comuna!');
        return; 
      }
    if(!vecinoData._id) 
    {
      // console.log('crear VECINO');
       await addDrop.mutateAsync( formData );
    } else
    { 
       await updateDropD.mutateAsync( formData );
    };
    onChangeVecino('REFRESH');
    setIsClicked( !isClicked.nuevoDrop );
  }


  return (
    <form  onSubmit={handleSubmit} >
       <div className="bg-half-transparent w-full fixed nav-item top-0 right-0">
     <div className="overflow-y-scroll float-right h-screen duration-1000 ease-in-out dark:text-gray-200 transition-all dark:bg-[#484B52] bg-gray-100  w-full md:w-3/4 p-8">
        <div className="flex justify-between items-center px-4 py-2 border-b border-gray-200 bg-white rounded-t-md shadow-sm">

            <div className="flex items-center gap-2">
              <div className="w-2.5 h-2.5 rounded-full bg-blue-500 animate-pulse" />
                <p className="text-gray-800 font-semibold text-base md:text-lg">
                  {!vecinoData ? "Nuevo" : "Editar"} Drop Off
                </p>
              </div>

              <button
                  type="button"
                  onClick={() => setIsClicked(!isClicked.nuevoDrop)}
                  className="text-gray-400 hover:text-red-500 transition-colors duration-150 p-2 rounded-full hover:bg-gray-100"
                  aria-label="Cerrar"
                >
                <MdOutlineCancel className="text-xl md:text-2xl" />
              </button>
          </div>

          <div className="mt-5 space-y-4">
              <div className="md:col-span-2 bg-white p-6 rounded-lg shadow-lg">
                <div className="grid grid-cols-1 md:grid-cols-5 gap-4" >
                  <div className="flex flex-col">
                    <label className="text-xs font-semibold mb-1">Código</label>
                    <input
                        className={inputClass}
                        type="text"
                        placeholder=""
                        name="codigo"
                        value= {formData.codigo}
                        required
                        onChange={handleChange}
                      />
                  </div>
                  <div className="col-span-2">
                    <div className="flex flex-col">
                      <label className="text-xs font-semibold mb-1">Nombre</label>
                      <input
                          className={inputClass}
                          type="text"
                          placeholder=""
                          name="nombrePunto"
                          value= {formData.nombrePunto}
                          required
                          onChange={handleChange}
                        />
                    </div>
                  </div>
                  <div className="col-span-2">
                  <div className="flex flex-col">
                    <label className="text-xs font-semibold mb-1">Dirección</label>
                    <input
                        className={inputClass}
                        type="text"
                        placeholder=""
                        name="direccion"
                        value= {formData.direccion}
                        required
                        onChange={handleChange}
                      />
                  </div>
                  </div>
              </div>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-2" >
              <div className="flex flex-col">
                    <label className="text-xs font-semibold mb-1">Teléfono</label>
                    <input
                        className={inputClass}
                        type="text"
                        placeholder=""
                        name="telefono"
                        value= {formData.telefono}
                        required
                        onChange={handleChange}
                      />
                  </div>
                  <div className="flex flex-col">
                    <label className="text-xs font-semibold mb-1">Mail</label>
                    <input
                        className={inputClass}
                        type="text"
                        placeholder=""
                        name="email"
                        value= {formData.email}
                        required
                        onChange={handleChange}
                      />
                  </div>


                  <div className="flex flex-col">
                    <label className="text-xs font-semibold mb-1">Comuna</label>
                    <Select
                      options={comunaOptions}
                      value={comunaOptions.find((option) => option.value === formData.idComuna)}
                      onChange={(selectedOption) => {
                        if (selectedOption) {
                          const comunaSeleccionada = comunaData.find(c => c._id === selectedOption.value);

                          setFormData((prev) => ({
                            ...prev,
                            idComuna: selectedOption.value,
                            nombreCiudad: comunaSeleccionada?.nombreCiudad || '',
                          }));
                        } else {
                          // Si se limpia el campo
                          setFormData((prev) => ({
                            ...prev,
                            idComuna: '',
                            nombreCiudad: '',
                          }));
                        }
                      }}
                      className="text-xs"
                      placeholder="Buscar ..."
                      isClearable
                      disabled = {!vecinoData._id ? false : true}
                    />

                  </div>
                  <div className="flex flex-col">
                    <label className="text-xs font-semibold mb-1">Ciudad</label>
                    <input
                        className={inputClass}
                        type="text"
                        placeholder=""
                        name="nombreCiudad"
                        value= {formData.nombreCiudad}
                        disabled
                        onChange={handleChange}
                      />
                  </div>
                </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-2" >

                  <div className="flex flex-col">
                      <label className="text-xs font-semibold mb-1">Estado</label>
                      <select className="text-xs border border-gray-300 p-2 rounded" name="estado" value= {formData.estado} required onChange={handleChange}>
                        <option value="ACTIVO">Activo</option>
                        <option value="INACTIVO">Inactivo</option>
                        <option value="ELIMINADO">Eliminado</option>
                      </select>
                  </div>

              </div>    

                <div className="grid grid-cols-1 md:grid-cols-1 gap-4 mt-2" >
                  <div className="flex flex-col">
                    <label className="text-xs font-semibold mb-1">Observación</label>
                    <input
                        className={inputClass}
                        type="text"
                        placeholder=""
                        name="descripcion"
                        value= {formData.descripcion}
                        required
                        onChange={handleChange}
                      />
                  </div>
                </div>  
              </div>
              <div className="bg-white p-6 rounded-lg shadow-lg items-end">
                  <button
                      onClick={handleSubmit}
                      className="bg-blue-600 text-white py-2 px-4 rounded mt-4"
                  >
                    { !vecinoData ? "Crear Nuevo": "Guardar Cambios"}
                  </button>
              </div>
              <Toaster  position="top-right"  toastOptions={{  style: {  zIndex: 9999,  },  }} />             
              <FooterPages />  
          </div>

        </div>
      </div>
    </form>
  );
};

export default NewDrop;